import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, ListTypeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ACTION, } from "./types";
import { ROUTE } from "../../../routes";
import { getActualLimit, getPortfolioValue, getTotalLimit } from "./actions";
import SharedPropsService from "../../../SharedPropsService";
import sharedPropsService from "../../../SharedPropsService";
import { addCommasToNumber, getMinAllowedAmountBasedOnLender, roundDownToNearestHundred, allowDynamicLimitFromBE } from "../../../configs/utils";
import { getDesiredValue } from "../portfolio_readonly/actions";
import { MIN_LIMIT } from "../../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { isDarkModeTheme } from "../../../configs/config";
let isDarkMode = isDarkModeTheme();
export const portfolioListDatastoreBuilderV2 = async (stepResponseObject, searchKeyword = "", totalCreditAmount, minimumAmount) => {
    const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
    const selectedMap = {};
    const listItemDataProps = [];
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    const user = await SharedPropsService.getUser();
    const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
    const notEligibleFlag = allowDynamicLimitFromBEFlag
        ? (totalCreditAmount < minimumAmount)
        : (typeof totalCreditAmount === 'number' &&
            (isEnhancedLimit
                ? (totalCreditAmount < MIN_LIMIT.ENHANCE_LIMIT)
                : (totalCreditAmount < getMinAllowedAmountBasedOnLender(user?.linkedApplications[0]?.lenderAccountId))));
    stepResponseObject.availableCAS.forEach((item, index) => {
        const key = `${item.isinNo}-${item.folioNo}`;
        selectedMap[index] = updateAvailableCASMap[key].pledgedUnits > 0;
        stepResponseObject.availableCAS[index] = updateAvailableCASMap[key];
        const title = `₹ ${addCommasToNumber(roundDownToNearestHundred(getTotalLimit([updateAvailableCASMap[key]], stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap)))}`;
        const subTitle = `/ ₹ ${addCommasToNumber(roundDownToNearestHundred(getActualLimit([updateAvailableCASMap[key]], stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap)))}`;
        const portfolioValue = `Value: ₹${addCommasToNumber(roundDownToNearestHundred(getPortfolioValue([updateAvailableCASMap[key]], stepResponseObject.isinNAVMap)))}`;
        listItemDataProps.push({
            label: updateAvailableCASMap[key].schemeName,
            info: "",
            secondaryText: portfolioValue,
            trailIcon: {
                name: updateAvailableCASMap[key].pledgedUnits > 0
                    ? IconTokens.CheckedSquare
                    : IconTokens.NotCheckedSquare,
            },
            trailTitle: title,
            trailSubTitle: subTitle,
            action: "edit",
            trailIconAction: {
                type: ACTION.EDIT_ITEM,
                routeId: ROUTE.PORTFOLIO,
                payload: {
                    stepResponseObject,
                    selectedMap: selectedMap,
                },
            },
        });
    });
    const props = {
        type: ListTypeTokens.CHECKLIST,
        data: [
            ...listItemDataProps.filter((item) => JSON.stringify(item.label.toUpperCase()).includes(searchKeyword.toUpperCase())),
        ],
        selectedMap: { ...selectedMap },
        action: {
            type: ACTION.TOGGLE_ITEM,
            routeId: ROUTE.PORTFOLIO,
            payload: {
                stepResponseObject,
                selectedMap,
            },
        },
    };
    const datastoreObj = {
        listItem: props,
        totalItem: {
            type: StackType.column,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "totalCreditLineCard", type: WIDGET.STACK },
                { id: "totalItemSpace0", type: WIDGET.SPACE },
                { id: "ContinueButtonStack", type: WIDGET.STACK },
            ],
        },
        ContinueButtonStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [{ id: "ContinueButton", type: WIDGET.BUTTON }],
        },
        spaceMD: {
            size: SizeTypeTokens.MD
        },
        totalItemSpace0: { size: SizeTypeTokens.LG },
        totalItemSpace1: { size: SizeTypeTokens.XL },
        totalCreditLineCard: {
            type: StackType.column,
            widgetItems: [
                { id: "CardSpaceHeader", type: WIDGET.SPACE },
                { id: "totalCreditLimitText", type: WIDGET.TEXT },
                { id: "totalCreditLimitStack", type: WIDGET.STACK },
                { id: "CardSpaceFooter", type: WIDGET.SPACE },
            ],
        },
        CardSpaceHeader: { size: SizeTypeTokens.LG },
        CardSpaceFooter: { size: SizeTypeTokens.XL },
        totalCreditLimitStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.flexEnd,
            widgetItems: [
                { id: "outOfTextStack", type: WIDGET.STACK },
            ],
        },
        outOfTextStack: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "outOfText1", type: WIDGET.TEXT },
                { id: "outOfText2", type: WIDGET.TEXT },
            ],
        },
        outOfText1: {
            label: `₹${addCommasToNumber(roundDownToNearestHundred(getTotalLimit(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap)))}`,
            fontWeight: "600",
            fontSize: FontSizeTokens.XL,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
            lineHeight: 28,
            fontFamily: FontFamilyTokens.Inter
        },
        outOfText2: {
            label: `/ ₹${addCommasToNumber(parseInt(stepResponseObject["availableCreditAmount"].toString()))}`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XS,
            color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
            lineHeight: 18
        },
        totalCreditLimitText: {
            label: "Selected credit limit",
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.SM,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            lineHeight: 20
        },
        ContinueButton: {
            id: 'bt_setCreditLimit_confirmAmount',
            label: "Confirm limit and proceed",
            // type: typeof totalCreditAmount === 'number' && 
            //     (isEnhancedLimit 
            //         ? (totalCreditAmount < MIN_LIMIT.ENHANCE_LIMIT) 
            //         : (totalCreditAmount < getMinAllowedAmountBasedOnLender(user?.linkedApplications[0]?.lenderAccountId))
            //     ) ? ButtonTypeTokens.LargeOutline 
            //     : ButtonTypeTokens.LargeFilled,
            type: notEligibleFlag ? ButtonTypeTokens.LargeOutline : ButtonTypeTokens.LargeFilled,
            fontFamily: FontFamilyTokens.Inter,
            isDarkMode: isDarkMode ? true : false,
            fontWeight: "700",
            fontSize: FontSizeTokens.SM,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.PORTFOLIO,
                payload: { value: stepResponseObject },
                routeId: ROUTE.PORTFOLIO,
            },
        },
    };
    return datastoreObj;
};
export const togglePortfolio = async (index, isPledged, stepResponseObject) => {
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    const item = stepResponseObject.availableCAS[index];
    const key = `${item.isinNo}-${item.folioNo}`;
    updateAvailableCASMap[key].pledgedUnits = isPledged
        ? updateAvailableCASMap[key].totalAvailableUnits
        : 0;
    await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
    await sharedPropsService.setCreditLimit(getTotalLimit(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap));
    const portValue = getDesiredValue(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap);
    await SharedPropsService.setDesiredPortfolio(portValue);
    return updateAvailableCASMap;
};
export const customEditPortfolio = async (index, amount, stepResponseObject) => {
    const updateAvailableCASMap = await SharedPropsService.getAvailableCASMap();
    const item = stepResponseObject.availableCAS[index];
    const key = `${item.isinNo}-${item.folioNo}`;
    updateAvailableCASMap[key].pledgedUnits =
        amount /
            (stepResponseObject.isinNAVMap[updateAvailableCASMap[key].isinNo] *
                stepResponseObject.isinLTVMap[updateAvailableCASMap[key].isinNo]);
    await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
};
